// constants/facilityTypes.js
//
// Single source of truth for facility site types. Every page that needs
// this list (scheduling, KPIs, coordinates, bulk facility upload, etc.)
// should import SITE_TYPES from here rather than defining its own local
// copy ” four separate pages each maintaining an identical hardcoded array
// is exactly how this list silently went stale (missing 6 real types, and
// one wrong name ” 'Regional Hospital' instead of 'Regional Referral
// Hospital') without anyone noticing across all four places at once.
//
// If a new site type is ever introduced, this is the ONE file to update.

export const SITE_TYPES = [
    'Clinic without Maternity',
    'Clinic with Maternity',
    'Health Centre',
    'Hospital',
    'National Referral Hospital',
    'Private Hospital',
    'Public Health Unit',
    'Regional Referral Hospital',
    'Specialized Clinic',
    'Specialized Hospital',
];

